import React from "react";
import { Row, Table } from "react-bootstrap";
import {useSelector } from "react-redux";
import { Frequencies, FrequencyValues,BotTypeName } from "../../../Const";

const RentBotSetting = (props) => {
  const { bot } = props;
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const stoploss = bot.stop_loss || 0;
  const theme = useSelector((state) => state.settings.selected_theme);
  const entryIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "entry")
      .map((item) => item.name)
      .join(", ");
  const exitIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "exit")
      .map((item) => item.name)
      .join(", ");

  return (
    <Row>
      <Table responsive className={`theme-bg ${theme}`}>
        <thead>
          <tr>
            <th>Brokerage</th>
            <th>Pair</th>
            <th>Bot Type</th>
            <th>Strategy</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                <img
                  src={exchange.image}
                  width={20}
                  height={20}
                  style={{ marginRight: 10 }}
                />
                <span style={{ fontWeight: "bold" }}>{exchange.name}</span>
              </div>
            </td>
            <td>{pair && `${pair.from}/${pair.to}`}</td>
            <td>Rent Bot</td>
            <td>{bot && bot.strategy}</td>
            <td>
              {bot && Frequencies[FrequencyValues.indexOf(bot.frequency)]}
            </td>
          </tr>
        </tbody>
      </Table>
    </Row>
  );
};

export default RentBotSetting;
